import { gsap } from 'gsap';

document.addEventListener('DOMContentLoaded', (event) => {
  const animate = document.querySelector('.animate-headlines');

  if (animate) {
    let tl = gsap.timeline({ repeat: -1 });

    gsap.set('.ce-headline-2', { y: 20 });
    gsap.set('.ce-headline-3', { y: 20 });
    gsap.set('.ce-headline-4', { y: 20 });

    tl.to(
      '.ce-headline-1',
      {
        duration: 2,
        autoAlpha: 0,
        y: 20,
        ease: 'expo.inOut',
      },
      4
    )
      .to(
        '.ce-headline-2',
        {
          duration: 2,
          autoAlpha: 1,
          y: 0,
          ease: 'expo.inOut',
        },
        '-=1'
      )
      .to(
        '.ce-headline-2',
        {
          duration: 2,
          autoAlpha: 0,
          y: 20,
          ease: 'expo.inOut',
        },
        '+=4'
      )
      .to(
        '.ce-headline-3',
        {
          duration: 2,
          autoAlpha: 1,
          y: 0,
          ease: 'expo.inOut',
        },
        '-=1'
      )
      .to(
        '.ce-headline-3',
        {
          duration: 2,
          autoAlpha: 0,
          y: 20,
          ease: 'expo.inOut',
        },
        '+=4'
      )
      .to(
        '.ce-headline-4',
        {
          duration: 2,
          autoAlpha: 1,
          y: 0,
          ease: 'expo.inOut',
        },
        '-=1'
      )
      .to(
        '.ce-headline-4',
        {
          duration: 2,
          autoAlpha: 0,
          y: 20,
          ease: 'expo.inOut',
        },
        '+=4'
      )
      .to(
        '.ce-headline-1',
        {
          duration: 2,
          autoAlpha: 1,
          y: 0,
          ease: 'expo.inOut',
        },
        '-=1'
      );

    tl.play();
  }
});
